<template>
<div class="default-vue">
    <div v-if="title && title.length" class="gdlr-item gdlr-item-title-wrapper pos-center">
        <div class="gdlr-item-title-head">
            <h3 class="gdlr-item-title gdlr-skin-border gdlr-skin-title" :class="'gdlr-title-'+titlesize" :style="{'text-align':titleAlign}">{{title}}</h3>
        </div>
    </div>
    <!--fitrows / marketing sponsors-->
    <div v-if="(displayMode == 'fitRows')" class="sponsor-item-wrapper" :style="{'margin-bottom':marginbottom}">
        <div v-if="loading">
            <img class="hidden-xs" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Sponsoren_Placeholder_Desktop_v2.svg" alt="">
        </div>
        <div v-if="result2 && result2.vueMarketingPartnerTypes && result2.vueMarketingPartnerTypes.MarketingPartnerTypes && sponsortype == 'marketing'  && !error2 && !loading2" class="sponsor-item-holder" :class="{'gdlr-sponsor-type-round': sponsorstyle == 'round','gdlr-sponsor-type-circle': sponsorstyle == 'circle'}">
            <div v-for="aSponsor in result2.vueMarketingPartnerTypes.MarketingPartnerTypes" :key="aSponsor._id">
                <div v-if="aSponsor && aSponsor.marketingPartners && aSponsor.marketingPartners.length" class='column twelve'>
                    <div v-if="aSponsor.displayNameDe && aSponsor.displayNameDe != 'null'" class="partnerName language-dependent-block-invisible-de gdlr-item-title-wrapper gdlr-nav-container ml-4">
                        <h3>{{aSponsor.displayNameDe}}</h3>
                    </div>
                    <div v-if="aSponsor.displayNameEn && aSponsor.displayNameEn != 'null'" class="partnerName gdlr-item-title-wrapper language-dependent-block-invisible gdlr-nav-container ml-4">
                        <h3>{{aSponsor.displayNameEn}} </h3>
                    </div>
                    <div v-for="sponsor in aSponsor.marketingPartners" :key="sponsor" class="eachPartnerSliderContainer eachFitRowContainer col-xs-6 col-md-3 col-lg-2 px-0">
                        <div v-if="sponsor && sponsor._id">
                            <div class="gdlr-item gdlr-sponsor-item eachSlideContainer global-border-radius">
                                <div class="gdlr-ux gdlr-sponsor-item-ux">
                                    <div class="gdlr-sponsor-thumbnail" @click="showPopover(sponsor._id)">
                                        <img v-if="sponsor.logo && sponsor.logo.x" :src="sponsor.logo.x" alt="" class="cursorp">
                                        <div v-else-if="sponsor.name" class="sponsor-name-as-logo-wrapper">
                                            <h3 class="text-center cursorp">{{sponsor.name}}</h3>
                                        </div>
                                        <span class="gdlr-sponsor-thumbnail-overlay cursorp"></span>
                                    </div>

                                    <div class="gdlr-sponsor-item-content"></div>
                                </div>
                            </div>
                            <div class="eachSponsorPopover sandsSponsorModal d--none" :class="sponsor._id">
                                <div class='sandsSponsorModal-modal-flex' @click="hidePopover(sponsor._id,$event)">
                                    <div class='sandsSponsorModal-inner row disableClick'>
                                        <div class='col-xs-5 col-sm-3 imag1 sponsor-description disableClick hidden-xs'>
                                            <img class='disableClick' v-if="sponsor.logo && sponsor.logo.x" :src="sponsor.logo.x" alt="">
                                        </div>
                                        <div class="col-sm-9 col-xs-12 sponsor-description disableClick">
                                            <h3 v-if="sponsor.name" class="h4 websiteLink">{{sponsor.name}}</h3>
                                            <div class='disableClick vue-sponsor-info-wrapper'>
                                                <img class='disableClick image2 hidden-sm hidden-md hidden-lg' v-if="sponsor.logo && sponsor.logo.x" :src="sponsor.logo.x" alt="">
                                                <div class='disableClick'>
                                                    <p class='disableClick' v-if="sponsor.information"><span class='disableClick'>{{sponsor.information}}</span></p>
                                                </div>
                                                <div v-if="sponsor.websiteUrl" class="column twelve sponsor-urls disableClick">
                                                    <span v-if="sponsor.websiteUrl" class="sponsor-url">
                                                        <a class='websiteLink cursorp' :href="sponsor.websiteUrl" target="_blank">{{sponsor.websiteUrl}}</a>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--sales sponsors-->
        <div v-if="result && result.vuePartnerTypes && result.vuePartnerTypes.PartnerTypes && sponsortype == 'sales' && !error && !loading" class="sponsor-item-holder">
            <div v-for="aSponsor in orderThePartners(result.vuePartnerTypes.PartnerTypes)" :key="aSponsor._id" class='row-fluid'>
                <div v-if="aSponsor && aSponsor.partners && aSponsor.partners.length" class='column twelve'>
                    <div v-if="aSponsor.displayNameDe && aSponsor.displayNameDe != 'null'" class="partnerName language-dependent-block-invisible-de gdlr-item-title-wrapper gdlr-nav-container ml-4">
                        <h3>{{aSponsor.displayNameDe}}</h3>
                    </div>
                    <div v-if="aSponsor.displayNameEn && aSponsor.displayNameEn != 'null'" class="partnerName gdlr-item-title-wrapper language-dependent-block-invisible gdlr-nav-container ml-4">
                        <h3>{{aSponsor.displayNameEn}} </h3>
                    </div>
                    <div v-for="sponsor in aSponsor.partners" :key="sponsor" class="eachPartnerSliderContainer eachFitRowContainer col-xs-6 col-md-3 col-lg-2 px-0">
                        <div v-if="sponsor && sponsor._id">
                            <div class="gdlr-item gdlr-sponsor-item eachSlideContainer global-border-radius">
                                <div class="gdlr-ux gdlr-sponsor-item-ux">
                                    <div class="gdlr-sponsor-thumbnail" @click="showPopover(sponsor._id)">
                                        <img v-if="sponsor.logo && sponsor.logo.x" :src="sponsor.logo.x" alt="" class="cursorp">
                                        <div v-else-if="sponsor.name" class="sponsor-name-as-logo-wrapper">
                                            <h3 class="text-center cursorp">{{sponsor.name}}</h3>
                                        </div>
                                        <span class="gdlr-sponsor-thumbnail-overlay cursorp"></span>
                                    </div>

                                    <div class="gdlr-sponsor-item-content"></div>
                                </div>
                            </div>
                            <div class="eachSponsorPopover sandsSponsorModal d--none" :class="sponsor._id">
                                <div class='sandsSponsorModal-modal-flex' @click="hidePopover(sponsor._id,$event)">
                                    <div class='sandsSponsorModal-inner row disableClick'>
                                        <div class='col-xs-5 col-sm-3 imag1 disableClick hidden-xs'>
                                            <img class='disableClick' v-if="sponsor.logo && sponsor.logo.x" :src="sponsor.logo.x" alt="">
                                        </div>
                                        <div class="col-sm-9 col-xs-12 sponsor-description disableClick">
                                            <h3 v-if="sponsor.name" class="h4 websiteLink">{{sponsor.name}}</h3>
                                            <div class='disableClick vue-sponsor-info-wrapper'>
                                                <img class='disableClick image2 hidden-sm hidden-md hidden-lg' v-if="sponsor.logo && sponsor.logo.x" :src="sponsor.logo.x" alt="">
                                                <div class='disableClick'>
                                                    <p class='disableClick' v-if="sponsor.information"><span class='disableClick'>{{sponsor.information}}</span></p>
                                                </div>
                                                <div v-if="sponsor.websiteUrl" class="column twelve sponsor-urls disableClick">
                                                    <span v-if="sponsor.websiteUrl" class="sponsor-url">
                                                        <a class='websiteLink' :href="sponsor.websiteUrl" target="_blank">{{sponsor.websiteUrl}}</a>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--carousel used only in landing page / marketing sponsors-->
    <div v-if="(displayMode == 'carousel') " :style="{'margin-bottom':marginbottom}">
        <div v-if="sponsortype == 'marketing' && result2 && result2.vueMarketingPartnerTypes && result2.vueMarketingPartnerTypes.MarketingPartnerTypes">
            <div v-for="(aSponsor, index) in orderThePartners(result2.vueMarketingPartnerTypes.MarketingPartnerTypes)" :key="index" class="eachPartnerSliderContainer col-xs-6 col-md-3 col-lg-2">
                <div v-if="aSponsor.displayNameDe && aSponsor.displayNameDe != 'null'" class="partnerName language-dependent-block-invisible-de gdlr-item-title-wrapper gdlr-item pos-center gdlr-nav-container ml-4">
                    <h3>{{aSponsor.displayNameDe}}</h3>
                </div>
                <div v-if="aSponsor.displayNameEn && aSponsor.displayNameEn != 'null'" class="partnerName gdlr-item-title-wrapper gdlr-item language-dependent-block-invisible pos-center gdlr-nav-container ml-4">
                    <h3>{{aSponsor.displayNameEn}} </h3>
                </div>
                <Splide :has-track="false" :options="options" :aria-label="aSponsor.displayNameDe + ' splideSlider'">
                    <SplideTrack>
                        <template v-for="sponsor in aSponsor.marketingPartners" :key="sponsor">
                            <SplideSlide>
                                <div class="eachSlideContainer">
                                    <div v-if="sponsor && sponsor.websiteUrl" @click="showPopover(sponsor._id)" >
                                        <img v-if="sponsor.logo && sponsor.logo.x" :src="sponsor.logo.x" class="cursorp global-border-radius" :alt="sponsor.name">
                                        <h3 v-else-if="sponsor.name" class="cursorp">{{sponsor.name}}</h3>
                                    </div>
                                </div>
                            </SplideSlide>
                        </template>
                    </SplideTrack>
                </Splide>
                <template v-for="sponsor in aSponsor.marketingPartners" :key="sponsor">
                    <div class="eachSponsorPopover sandsSponsorModal d--none" :class="sponsor._id">
                        <div class='sandsSponsorModal-modal-flex' @click="hidePopover(sponsor._id,$event)">
                            <div class='sandsSponsorModal-inner row disableClick'>
                                <div class='col-xs-5 col-sm-3 imag1 disableClick sponsor-description hidden-xs'>
                                    <img class='disableClick' v-if="sponsor.logo && sponsor.logo.x" :src="sponsor.logo.x" alt="">
                                </div>
                                <div class="col-sm-9 col-xs-12 sponsor-description disableClick">
                                    <div class='disableClick vue-sponsor-info-wrapper'>
                                        <img class='disableClick image2 hidden-sm hidden-md hidden-lg' v-if="sponsor.logo && sponsor.logo.x" :src="sponsor.logo.x" :alt="sponsor.name">
                                        <h3 v-if="sponsor.name" class="h4 websiteLink">{{sponsor.name}}</h3>
                                        <div class='disableClick'>
                                            <p class='disableClick' v-if="sponsor.information"><span class='disableClick'>{{sponsor.information}}</span></p>
                                        </div>
                                        <div v-if="sponsor.websiteUrl" class="column twelve sponsor-urls disableClick">
                                            <span v-if="sponsor.websiteUrl" class="sponsor-url">
                                                <a class='websiteLink cursorp' :href="sponsor.websiteUrl" target="_blank" >{{sponsor.websiteUrl}}</a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <!--sales sponsors-->
        <div v-if="sponsortype == 'sales' && result && result.vuePartnerTypes && result.vuePartnerTypes.PartnerTypes" :style="{'margin-bottom':marginbottom}" class="row allPartnersRow">
            <template v-for="(aSponsor, index) in orderThePartners(result.vuePartnerTypes.PartnerTypes)" :key="index">
                <!-- check if the partners array is not empty -->
                <div v-if="aSponsor.partners && aSponsor.partners.length" class="eachPartnerSliderContainer col-xs-6 col-md-3 col-lg-2">
                    <template v-if="aSponsor.partners && aSponsor.partners.length">
                        <div v-if="aSponsor.displayNameDe && aSponsor.displayNameDe != 'null'" class="partnerName language-dependent-block-invisible-de gdlr-item-title-wrapper gdlr-item pos-center gdlr-nav-container ml-4">
                            <h3>{{aSponsor.displayNameDe}}</h3>
                        </div>
                        <div v-if="aSponsor.displayNameEn && aSponsor.displayNameEn != 'null'" class="partnerName gdlr-item-title-wrapper gdlr-item language-dependent-block-invisible pos-center gdlr-nav-container ml-4">
                            <h3>{{aSponsor.displayNameEn}} </h3>
                        </div>
                    </template>

                    <Splide :has-track="false" :options="options" :aria-label="aSponsor.displayNameDe + ' splideSlider'" style="height: 100%;">
                        <SplideTrack>
                            <template v-for="sponsor in aSponsor.partners" :key="sponsor">
                                <SplideSlide>
                                    <div class="eachSlideContainer global-border-radius">
                                        <div v-if="sponsor && sponsor.websiteUrl" @click="showPopover(sponsor._id)">
                                            <img v-if="sponsor.logo && sponsor.logo.x" :src="sponsor.logo.x" :alt="sponsor.websiteUrl" class="cursorp" >
                                            <h3 v-else-if="sponsor.name" class="cursorp" >{{sponsor.name}}</h3>
                                        </div>
                                    </div>
                                </SplideSlide>
                            </template>
                        </SplideTrack>
                    </Splide>


                    <template v-for="sponsor in aSponsor.partners" :key="sponsor">
                        <div class="eachSponsorPopover sandsSponsorModal d--none" :class="sponsor._id">
                            <div class='sandsSponsorModal-modal-flex' @click="hidePopover(sponsor._id,$event)">
                                <div class='sandsSponsorModal-inner row disableClick'>
                                    <div class='col-xs-5 col-sm-3 imag1 disableClick sponsor-description hidden-xs'>
                                        <img class='disableClick' v-if="sponsor.logo && sponsor.logo.x" :src="sponsor.logo.x" alt="">
                                    </div>
                                    <div class="col-sm-9 col-xs-12 sponsor-description disableClick">
                                        <div class='disableClick vue-sponsor-info-wrapper'>
                                            <img class='disableClick image2 hidden-sm hidden-md hidden-lg' v-if="sponsor.logo && sponsor.logo.x" :src="sponsor.logo.x" alt="">
                                            <h3 v-if="sponsor.name" class="h4 websiteLink">{{sponsor.name}}</h3>
                                            <div class='disableClick'>
                                                <p class='disableClick' v-if="sponsor.information"><span class='disableClick'>{{sponsor.information}}</span></p>
                                            </div>
                                            <div v-if="sponsor.websiteUrl" class="column twelve sponsor-urls disableClick">
                                                <span v-if="sponsor.websiteUrl" class="sponsor-url">
                                                    <a class='websiteLink' :href="sponsor.websiteUrl" target="_blank">{{sponsor.websiteUrl}}</a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </template>


        </div>
    </div>
    <div v-if="displayMode == 'fullContent'" class="gdlr-color-wrapper gdlr-show-all no-skin mlc-location-dependent-block-visible global-bg-color" :style="{'margin-bottom':marginbottom}">
        <div v-if="sponsortype == 'marketing' && result2 && result2.vueMarketingPartnerTypes && result2.vueMarketingPartnerTypes.MarketingPartnerTypes" class="container">
            <div v-for="aSponsor in orderThePartners(result2.vueMarketingPartnerTypes.MarketingPartnerTypes)" :key="aSponsor._id" class="sponsor-item-wrapper sponsor-group">
                <div v-if="aSponsor.displayNameDe && aSponsor.displayNameDe != 'null'" class="language-dependent-block-invisible-de column twelve text-right sponsor-type-title">
                    <h3 class="align-sponsor-name">{{aSponsor.displayNameDe}}</h3>
                </div>
                <div v-if="aSponsor.displayNameEn && aSponsor.displayNameEn != 'null'" class="language-dependent-block-invisible column twelve text-right sponsor-type-title">
                    <h3 class="align-sponsor-name">{{aSponsor.displayNameEn}}</h3>
                </div>
                <div v-for="sponsor in aSponsor.marketingPartners" :key="sponsor">
                    <div class="sponsor-item-holder gdlr-sponsor-type-round">
                        <div class="row-fluid sponsor-group">

                            <div class="column twelve single-sponsor">
                                <div v-if="sponsor.name" class="sponsor-title">
                                    <h3 class="gdlr-blog-title sands-blog-title"><a :href="sponsor.websiteUrl">{{sponsor.name}}</a></h3>
                                </div>
                                <div class="column four sands-sponsor-logo">
                                    <div class="gdlr-sponsor-thumbnail">
                                        <a class="cursorp"  v-if="sponsor.logo && sponsor.logo.x" :href="'partners/' + sponsor.name"><img :src="sponsor.logo.x" class="attachment-post-thumbnail size-post-thumbnail wp-post-image" :alt="sponsor.name"></a>
                                    </div>
                                </div>
                                <div class="column eight sponsor-description">
                                    <p><span>{{sponsor.information}}</span></p>
                                    <!--EndFragment-->
                                    <p><br></p>
                                    <p><br></p>
                                    <div class="column twelve sponsor-urls">
                                        <span class="column two url-label">URL: </span>
                                        <span class="column ten url-list">
                                            <span v-if="sponsor.websiteUrl" class="sponsor-url">
                                                <ul>
                                                    <li><a :href="sponsor.websiteUrl" target="_blank">{{sponsor.websiteUrl}}</a></li>
                                                </ul>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--sales sponsors-->
        <div v-if="sponsortype == 'sales' && result && result.vuePartnerTypes && result.vuePartnerTypes.PartnerTypes  && !error && !loading" class="container">
            <div v-for="aSponsor in orderThePartners(result.vuePartnerTypes.PartnerTypes)" :key="aSponsor._id" class="sponsor-item-wrapper sponsor-group">
                <div v-if="aSponsor.displayNameDe && aSponsor.displayNameDe != 'null'" class="language-dependent-block-invisible-de column twelve text-right sponsor-type-title">
                    <h3 class="align-sponsor-name">{{aSponsor.displayNameDe}}</h3>
                </div>
                <div v-if="aSponsor.displayNameEn && aSponsor.displayNameEn != 'null'" class="language-dependent-block-invisible column twelve text-right sponsor-type-title">
                    <h3 class="align-sponsor-name">{{aSponsor.displayNameEn}}</h3>
                </div>
                <div v-for="sponsor in aSponsor.partners" :key="sponsor">
                    <div class="sponsor-item-holder gdlr-sponsor-type-round">
                        <div class="row-fluid sponsor-group">

                            <div class="column twelve single-sponsor">
                                <div v-if="sponsor.name" class="sponsor-title">
                                    <h3 class="gdlr-blog-title sands-blog-title"><a :href="sponsor.websiteUrl">{{sponsor.name}}</a></h3>
                                </div>
                                <div class="column four sands-sponsor-logo">
                                    <div class="gdlr-sponsor-thumbnail">
                                        <a v-if="sponsor.logo && sponsor.logo.x" class="cursorp"  :href="'partners/' + sponsor.name"><img :src="sponsor.logo.x" class="attachment-post-thumbnail size-post-thumbnail wp-post-image" :alt="sponsor.name"></a>
                                    </div>
                                </div>
                                <div class="column eight sponsor-description">
                                    <p><span>{{sponsor.information}}</span></p>
                                    <!--EndFragment-->
                                    <p><br></p>
                                    <p><br></p>
                                    <div class="column twelve sponsor-urls">
                                        <span class="column two url-label">URL: </span>
                                        <span class="column ten url-list">
                                            <span v-if="sponsor.websiteUrl" class="sponsor-url">
                                                <ul>
                                                    <li><a :href="sponsor.websiteUrl" target="_blank">{{sponsor.websiteUrl}}</a></li>
                                                </ul>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="error">
            Something went wrong
        </div>
        <div v-if="loading" class="container">
            <img class="hidden-md hidden-sm hidden-xs" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Speaker_Detail_Placeholder_Desktop_v1.svg" alt="">
            <img class="hidden-lg hidden-sm hidden-xs" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Speaker_Detail_Placeholder_Tablet_v1.svg" alt="">
            <img class="hidden-md hidden-lg" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Speaker_Detail_Placeholder_Mobile_v1.svg" alt="">
        </div>
    </div>
</div>
</template>

<script>
import queryAndMutaionService from '@/services/queryAndMutaionService'
import {
    Splide,
    SplideSlide,
    SplideTrack
} from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css';
import '@splidejs/vue-splide/css/core';

export default {
    name: 'SponsorsDisplay',
    props: {
        settingsPerm: Object

    },
    components: {
        Splide,
        SplideSlide,
        SplideTrack
    },
    data() {
        return {
            Sponsors: false,
            result: null,
            result2: null,
            loading: false,
            error: true,
            jQuery: window.jQuery,
            loading2: false,
            error2: true,
            calledJquery: false,
            page: this.settingsPerm.page,
            pagesize: this.settingsPerm.pagesize,
            titleAlign: this.settingsPerm.titletype,
            title: null,
            titlesize: this.settingsPerm.titlesize,
            displayMode: this.settingsPerm.sponsorlayout,
            thumbnailsize: this.settingsPerm.thumbnailsize,
            sponsorsize: this.settingsPerm.sponsorsize,
            sponsorstyle: this.settingsPerm.sponsorstyle, //round or cirlce class
            sponsortype: this.settingsPerm.sponsortype,
            currentinstance: this.settingsPerm.currentinstance,
            instanceid: this.settingsPerm.instanceid,
            marginbottom: this.settingsPerm.marginbottom,
            order: this.settingsPerm.order,
            orderby: this.settingsPerm.orderby,
            seriesid: this.settingsPerm.seriesid,
            options: null,
            cookie: window.jQuery.cookie("event_location"),
            theMaybeSetPLLCookieValue: window.jQuery.cookie("pll_language"),
        }
    },
    created() {
        if (this.settingsPerm && this.settingsPerm.title && this.settingsPerm.title.length) {
            this.title = this.settingsPerm.title.replace(/_/g, ' ');
        }
        if (this.seriesid) {
            let concordData;
            let concordData2;
            if (this.sponsortype && this.sponsortype == 'marketing') {
                concordData2 = queryAndMutaionService.getMarketingSponsors(this.seriesid);
            }
            if (this.sponsortype && this.sponsortype == 'sales') {
                concordData = queryAndMutaionService.getSalesSponsors(this.seriesid);
            }
            //sales
            if (concordData && concordData.result) {
                this.result = concordData.result;
            }
            if (concordData && concordData.loading) {
                this.loading = concordData.loading;
            }
            if (concordData && concordData.error) {
                this.error = concordData.error;
            }
            //marketing
            if (concordData2 && concordData2.result) {
                this.result2 = concordData2.result;
            }
            if (concordData2 && concordData2.loading) {
                this.loading2 = concordData2.loading;
            }
            if (concordData2 && concordData2.error) {
                this.error2 = concordData2.error;
            }
        }

        var fixedWidth = '';

        if (this.sponsorsize == 4) {
            fixedWidth = '25rem';
        } else if (this.sponsorsize == 3) {
            fixedWidth = '35rem';
        } else if (this.sponsorsize == 2) {
            fixedWidth = '53rem';
        }
        if (fixedWidth && fixedWidth.length) {
            this.options = {
                rewind: true,
                gap: '1em',
                height: '100%',
                pagination: false,
                perPage: 1,
                perMove: 1,
                autoplay: 'false',
                arrows: false,

            }
        } else {
            this.options = {
                rewind: true,
                gap: '1em',
                pagination: false,
                perPage: 1,
                perMove: 1,
                autoplay: 'false',
                arrows: false,
            }
        }
    },
    beforeUpdate() {},
    updated() {
        if (window) {
             this.cookie = window.jQuery.cookie("event_location");
            if (this.cookie && (typeof this.cookie !== "undefined") && (this.cookie != "") && (this.cookie != "all")) {
                window.jQuery('.mlc-location-dependent-block-invisible.' + this.cookie).addClass('mlc-location-dependent-block-visible');
                window.jQuery('.mlc-location-dependent-block-invisible.' + this.cookie).removeClass('mlc-location-dependent-block-invisible');
            } else {
                // we do NOT have a location so we do somtehing with location dependend things
                window.jQuery('.mlc-location-independent-block-invisible').addClass('mlc-location-independent-block-visible');
                window.jQuery('.mlc-location-independent-block-invisible').removeClass('mlc-location-independent-block-invisible');
            }
            if (this.theMaybeSetPLLCookieValue && (typeof this.theMaybeSetPLLCookieValue !== "undefined") && (this.theMaybeSetPLLCookieValue != "") && (this.theMaybeSetPLLCookieValue == 'de')) {
                window.jQuery('.language-dependent-block-invisible-de').addClass('language-dependent-block-visible');
                window.jQuery('.language-dependent-block-invisible-de').removeClass('language-dependent-block-invisible-de');
            } else {
                window.jQuery('.language-dependent-block-invisible').addClass('language-dependent-block-visible');
                window.jQuery('.language-dependent-block-invisible').removeClass('language-dependent-block-invisible');
            }
        }
    },
    methods: {
        orderThePartners(partnertypes) {
            if (partnertypes && partnertypes.length) {
                let arrayForSort = [...partnertypes]
                return arrayForSort.sort((a, b) => a.order - b.order);
            }
        },
        showPopover(sponsorId) {
            if (sponsorId) {
                var sandsSponsorModal = this.jQuery("." + sponsorId);
                if (sandsSponsorModal && sandsSponsorModal.length) {
                    sandsSponsorModal.show();
                    sandsSponsorModal.find(".sandsSponsorModal-modal-flex").addClass("active");
                }
            }
        },
        hidePopover(sponsorId, event) {
            if (sponsorId && event) {
                if (event.target && event.target.classList && event.target.classList.length && event.target.classList.contains('disableClick')) {
                    return;
                }
                var sandsSponsorModal = this.jQuery("." + sponsorId);
                sandsSponsorModal.hide();
                sandsSponsorModal.find(".sandsSponsorModal-modal-flex").removeClass("active");
            }
        }
    },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.splide.is-active .splide__list {
    display: flex;
}

.m--t--1 {
    margin-top: 8px;
}

.sponsor-name-as-logo-wrapper {
    height: 256px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.sponsor-name-as-logo-wrapper h3{
    font-weight:600;
}

.slider-box {
    margin: 5px;
    padding: 5px;
}

.eachSlideContainer {
    display: flex;
    justify-content: center;
    padding: 14px;
    align-items: center;
    background-color: white;;
    border-radius: 30px;
    border: 1.8px solid #80808033;
}

.splide__arrow .your-class-arrow {
    background: none !important;
}

.eachPartnerSliderContainer {
    display: flex;
    flex-direction: column;
    margin-bottom: 6rem !important;
}

.partnerName {
    height: 100%;
    font-family: 'Open Sans';
    margin-top: 1rem!important;;
    margin-bottom: 1rem!important;;
}

.partnerName h3{
    word-break: break-word;
    border-left: 30px;
    font-size: 18px;
    text-align: start;
    margin-left: 0px;
    text-transform: none !important;
    font-weight: 700;
    line-height: 25px;
}

.allPartnersRow {
    display: flex;
    flex-wrap: wrap;
}

.sandsSponsorModal.d--none {
    display: none;
}

.sandsSponsorModal {
    background-color: rgba(0, 0, 0, 0.5);
    cursor: pointer;
    height: 100%;
    left: 0;
    position: fixed;
    overflow: scroll;
    top: 70px;
    width: 100%;
    z-index: 1;
}

@media screen and (max-width: 782px) {
    .sandsSponsorModal {
        top: 0px;
    }
}
@media screen and (max-width: 768px) {
    .partnerName h3{
    font-size: 16px;
    line-height: 22px;
    }
}
@media screen and (max-width: 426px) {
    .partnerName h3{
    font-size: 14px;
    line-height: 20px;
}
}

.sandsSponsorModal .sandsSponsorModal-modal-flex {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
}

.sandsSponsorModal .sandsSponsorModal-modal-flex.active {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    -o-justify-content: center;
    justify-content: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    align-items: center;
}

.sandsSponsorModal .inner {
    border-radius: 4px;
    max-height: 95%;
    max-width: 95%;

    background-color: #f0f1f2;
    cursor: auto;
    display: block;
    left: initial;
    position: relative;
    opacity: 1;
    overflow: scroll;
    overflow-x: hidden;
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
    width: 600px;
    z-index: 21;
}

.sandsSponsorModal .sponsor-description {
    margin-top: 20px;
    margin-bottom: 20px;
}

.sponsor-description .vue-sponsor-info-wrapper {
    overflow-y: scroll;
    max-height: 370px;
    overflow-x: hidden;
    padding-right: 10px;
    padding-bottom: 10px;
}

.vue-sponsor-info-wrapper .image2 {
    max-height: 140px;
}

.vue-sponsor-info-wrapper {
    scrollbar-color: rgba(0, 0, 0, 0.5) rgba(0, 0, 0, 0);
    scrollbar-width: thin;
}

.vue-sponsor-info-wrapper::-webkit-scrollbar {
    width: 12px;
    -moz-appearance: none;
}

.vue-sponsor-info-wrapper::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0px rgba(0, 0, 0, 0);
    -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0);
    border-radius: 10px;
}

.vue-sponsor-info-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}

.vue-sponsor-info-wrapper::scrollbar-track {
    box-shadow: inset 0 0 0px rgba(0, 0, 0, 0);
    -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0);
    border-radius: 10px;
}

.vue-sponsor-info-wrapper::scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}

.sandsSponsorModal-inner {
    background-color: #fff;
    cursor: auto;
    padding-left: 5px;
    display: block;
    left: initial;
    position: relative;
    opacity: 1;
    overflow: hidden;
    overflow-x: hidden;
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
    width: 750px;
    max-height: 470px;
    z-index: 21;
    border-radius: 25px;
    max-width: 95%;
}

.vue-sponsor-info-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}

.websiteLink {
    font-weight: 600;
    color: #000;
}
.cursorp{
    cursor: pointer;
}
</style>
